import axios from 'axios';

export function getHeader(lang) {
  return axios.get(`https://biconomyweb.oss-accelerate.aliyuncs.com/header/data/${lang}.json`);
}
